import { useQueryClient } from '@tanstack/react-query';

export const usePolicyGroupId = (
  uuid: string | undefined | null,
): string | null => {
  const queryClient = useQueryClient();

  if (!uuid) return null;

  const cachedFormData =
    queryClient.getQueryData<{ policy_group_id?: string }>([
      'app_form',
      uuid,
    ]) ||
    queryClient.getQueryData<{ policy_group_id?: string }>(['home_form', uuid]);

  return cachedFormData?.policy_group_id || null;
};
